import React, { Component } from 'react';
import ReactGA from 'react-ga4';
import { withRouter, IWithRouterProps } from '../../utils/withRouter';

export default function <P extends object>(WrappedComponent: React.ComponentType<P>) {
    const trackPage = (page: string) => {
        ReactGA.send({ hitType: 'pageview', page });
    };

    class Tracker extends Component<P & IWithRouterProps & { data?: any }> {
        public componentDidMount() {
            const page = this.props.location ? this.props.location.pathname : window.location.pathname;
            trackPage(page);
        }

        public componentDidUpdate(prevProps: P & IWithRouterProps & { data?: any }) {
            const currentPage = this.props.location ? this.props.location.pathname : window.location.pathname;
            const prevPage = prevProps.location ? prevProps.location.pathname : '';
            if (currentPage !== prevPage) {
                trackPage(currentPage);
            }
        }

        public render() {
            const { data, ...props } = this.props as any;
            return <WrappedComponent {...(props as P)} data={data} />;
        }
    }

    return withRouter(Tracker);
}
